module.exports = __webpack_public_path__ + "static/media/outerspace.24af1465.svg";